import {
    Component,
    ComponentDefinition,
    DisplayedComponent,
    ParentAwareComponent,
    ParentComponent,
} from "components/components/Component";
import { listenDataUpdateRequest } from "components/components/componentUpdateRequestedUtil";
import $ from "jquery";
import { I18nMessage, I18nMessageDefinition } from "../i18n/I18nMessage";


export class StackedPage implements ParentComponent, ParentAwareComponent, DisplayedComponent {

    public readonly componentType = "stackedPage";
    public view: HTMLElement;
    public definition: StackedPageDefinition;
    public id;
    public children = [];
    public parent: Component = null;

    constructor(definition: StackedPageDefinition) {
        this.definition = definition;
    }

    public render(): Element {
        const title = new I18nMessage(this.definition.pageTitle).toString();
        document.title = "SISLOG - " + title;

        this.view = $('<div class="c-stacked-page"></div>')[0];
        $(".js-stack-holder").trigger("pageStacked", [this]);
        listenDataUpdateRequest(this);
        return this.view;
    }

    public appendChildView = (childView: Node): void => {
        $(childView).appendTo($(this.view));
    }

    public postRender() {
        let focusable = this.view.querySelectorAll('button, [href], input:not([readonly]), select:not([readonly]), textarea:not([readonly]), [tabindex]:not([tabindex="-1"]), [data-s6-focusable=true]');
        if (focusable.length > 0) {
            (focusable[0] as HTMLElement).focus();
        }
    }
}

export interface StackedPageDefinition extends ComponentDefinition {
    pageTitle?: I18nMessageDefinition | string;
}
